/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import * as React from 'react';
import {ReactNode} from 'react';
import Props from './Props';
import {Alert, Button, Col, Row} from 'react-bootstrap';
import {css} from 'aphrodite/no-important';
import styles from './styles';

class Notification extends React.Component<Props> {

	static defaultProps: Partial<Props> = {
		hidden: false,
		level: 'success',
		onActionButtonClick: () => {
			// do nothing
		},
		onDismiss: () => {
			// do nothing
		}
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;

		return (
			<Row>
				<Col xs={12} sm={{span: 10, offset: 1}} md={{span: 8, offset: 2}} lg={{span: 6, offset: 3}}>
					<Alert
						variant={props.level}
						dismissible={true}
						onClose={props.onDismiss}
						className={css(styles.notification, props.hidden ? styles.hidden : styles.visible)}>
						{this.props.text}
						{!!props.textAfterActionButton && ' '}
						{props.actionButtonText &&
						<Button
							variant="link"
							onClick={props.onActionButtonClick}
							className={css(styles.actionButton, !!props.textAfterActionButton && styles.actionButtonEmbedded)}>
							<strong>{props.actionButtonText}</strong>
						</Button>
						}
						{props.textAfterActionButton ? (' ' + props.textAfterActionButton) : undefined}
					</Alert>
				</Col>
			</Row>

		);
	}
}

export default Notification;
